module.exports = __webpack_public_path__ + "img/safari.c9b6da29.svg";